"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mortgageCommonSagas = void 0;
var WindowApi_1 = require("@/api/browser/WindowApi");
var AffordabilityAction_1 = require("@/pages/mortagage/actions/AffordabilityAction");
var MortgageCommonAction_1 = require("@/pages/mortagage/actions/MortgageCommonAction");
var MortgageMonthlyAction_1 = require("@/pages/mortagage/actions/MortgageMonthlyAction");
var RefinanceAction_1 = require("@/pages/mortagage/actions/RefinanceAction");
var MortgageCommonSagaSelector_1 = require("@/pages/mortagage/sagas/MortgageCommonSagaSelector");
var effects_1 = require("redux-saga/effects");
var transformOutputToResult_1 = require("@/pages/mortagage/transformer/transformOutputToResult");
var getMortgageOutputs_1 = require("@okay/okay-mortgage/src/sagas/getMortgageOutputs");
var getMortgageRefinancingOutputs_1 = require("@okay/okay-mortgage/src/sagas/getMortgageRefinancingOutputs");
var getAffordabilityOutput_1 = require("@okay/okay-mortgage/src/sagas/getAffordabilityOutput");
var MortgageError_1 = require("@okay/okay-mortgage/src/states/MortgageError");
var getMortgageMonthlyOutput = function () {
    var mortgageMonthlyInputs, mortgageMonthlyOutputs;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(MortgageCommonSagaSelector_1.getMortgageMonthlyInputs)];
            case 1:
                mortgageMonthlyInputs = _a.sent();
                return [4 /*yield*/, effects_1.call(getMortgageOutputs_1.getMortgageOutputs, mortgageMonthlyInputs)];
            case 2:
                mortgageMonthlyOutputs = _a.sent();
                return [2 /*return*/, mortgageMonthlyOutputs];
        }
    });
};
var mortgageMonthlyInit = function () {
    var mortgageMonthlyOutputs, mortgageMonthlyResult;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(MortgageMonthlyAction_1.default.ON_CALCULATE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(getMortgageMonthlyOutput)];
            case 2:
                mortgageMonthlyOutputs = _a.sent();
                return [4 /*yield*/, effects_1.call(transformOutputToResult_1.transformMortgageMonthlyOutputToResult, mortgageMonthlyOutputs)];
            case 3:
                mortgageMonthlyResult = _a.sent();
                return [4 /*yield*/, effects_1.put(MortgageMonthlyAction_1.default.setResult(mortgageMonthlyResult))];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var mortgageMonthlyCalculateClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(MortgageMonthlyAction_1.default.ON_CALCULATE_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MortgageMonthlyAction_1.default.onCalculate())];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MortgageCommonAction_1.default.setResultVisible(true))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var mortgageMonthlyUpdate = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take([MortgageMonthlyAction_1.default.ON_LOANAMOUNT_PERCENT_CHANGED, MortgageMonthlyAction_1.default.ON_LOANAMOUNT_CHANGED, MortgageMonthlyAction_1.default.ON_TENOR_CHANGED, MortgageMonthlyAction_1.default.ON_INTEREST_RATE_CHANGED, MortgageMonthlyAction_1.default.ON_HAS_TRANSACTION_RECENTLY_CHANGED, MortgageMonthlyAction_1.default.ON_HAS_TRANSACTION_RECENTLY_MONTH_CHANGED, MortgageMonthlyAction_1.default.ON_NON_CORPORATE_CHANGED, MortgageMonthlyAction_1.default.ON_NON_FIRST_TIME_CHANGED, MortgageMonthlyAction_1.default.ON_HAS_OUTSTANDING_MORTGAGE_CHANGED])];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MortgageMonthlyAction_1.default.onCalculate())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var mortgageMonthlyUpdateAutoLoanAmount = function () {
    var mortgageMonthlyOutputs;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take([MortgageMonthlyAction_1.default.ON_PROPERTY_VALUE_CHANGED])];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(getMortgageMonthlyOutput)];
            case 2:
                mortgageMonthlyOutputs = _a.sent();
                if (!(mortgageMonthlyOutputs.error && mortgageMonthlyOutputs.error.type === MortgageError_1.MortgageErrorType.EXCEED_MORTGAGE_FIX_AMOUNT)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(MortgageMonthlyAction_1.default.onLoanAmountChanged("" + mortgageMonthlyOutputs.error.maxLoanAmount))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4:
                if (!(mortgageMonthlyOutputs.error && mortgageMonthlyOutputs.error.type === MortgageError_1.MortgageErrorType.EXCEED_MORTGAGE_PERCENT_AMOUNT)) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.put(MortgageMonthlyAction_1.default.onLoanAmountPercentChanged(mortgageMonthlyOutputs.error.maxLoanPercent))];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [4 /*yield*/, effects_1.put(MortgageMonthlyAction_1.default.onCalculate())];
            case 7:
                _a.sent();
                return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
var affordabilityInit = function () {
    var monthlyIncome, affordabilityOutput, affordabilityByIncomeInput, affordabilityInput, affordabilityResult;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 11];
                return [4 /*yield*/, effects_1.take(AffordabilityAction_1.default.ON_CALCULATE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(MortgageCommonSagaSelector_1.getIncome)];
            case 2:
                monthlyIncome = _a.sent();
                affordabilityOutput = void 0;
                if (!(monthlyIncome > 0)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.select(MortgageCommonSagaSelector_1.getAffordabilityByIncomeInputs)];
            case 3:
                affordabilityByIncomeInput = _a.sent();
                return [4 /*yield*/, effects_1.call(getAffordabilityOutput_1.getAffordabilityByIncomeOutput, affordabilityByIncomeInput)];
            case 4:
                affordabilityOutput = _a.sent();
                return [3 /*break*/, 8];
            case 5: return [4 /*yield*/, effects_1.select(MortgageCommonSagaSelector_1.getAffordabilityInputs)];
            case 6:
                affordabilityInput = _a.sent();
                return [4 /*yield*/, effects_1.call(getAffordabilityOutput_1.getAffordabilityOutput, affordabilityInput)];
            case 7:
                affordabilityOutput = _a.sent();
                _a.label = 8;
            case 8: return [4 /*yield*/, effects_1.call(transformOutputToResult_1.transformAffordabilityOutputToResult, affordabilityOutput)];
            case 9:
                affordabilityResult = _a.sent();
                return [4 /*yield*/, effects_1.put(AffordabilityAction_1.default.setResult(affordabilityResult))];
            case 10:
                _a.sent();
                return [3 /*break*/, 0];
            case 11: return [2 /*return*/];
        }
    });
};
var affordabilityCalculateClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(AffordabilityAction_1.default.ON_CALCULATE_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(AffordabilityAction_1.default.onCalculate())];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MortgageCommonAction_1.default.setResultVisible(true))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var affordabilityUpdate = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take([AffordabilityAction_1.default.ON_MONTHLY_INCOME_CHANGED, AffordabilityAction_1.default.ON_TENOR_CHANGED, AffordabilityAction_1.default.ON_INTEREST_RATE_CHANGED, AffordabilityAction_1.default.ON_HAS_TRANSACTION_RECENTLY_CHANGED, AffordabilityAction_1.default.ON_HAS_TRANSACTION_RECENTLY_MONTH_CHANGED, AffordabilityAction_1.default.ON_NON_CORPORATE_CHANGED, AffordabilityAction_1.default.ON_NON_FIRST_TIME_CHANGED, AffordabilityAction_1.default.ON_DOWN_PAYMENT_CHANGED, AffordabilityAction_1.default.ON_HAS_OUTSTANDING_MORTGAGE_CHANGED])];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(AffordabilityAction_1.default.onCalculate())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var refinanceInit = function () {
    var refinanceInputs, refinanceOutputs, refinanceResult;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(RefinanceAction_1.default.ON_CALCULATE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(MortgageCommonSagaSelector_1.getRefinanceInputs)];
            case 2:
                refinanceInputs = _a.sent();
                return [4 /*yield*/, effects_1.call(getMortgageRefinancingOutputs_1.getMortgageRefinancingOutputs, refinanceInputs)];
            case 3:
                refinanceOutputs = _a.sent();
                return [4 /*yield*/, effects_1.call(transformOutputToResult_1.transformRefinanaceOutputToResult, refinanceOutputs, refinanceInputs)];
            case 4:
                refinanceResult = _a.sent();
                return [4 /*yield*/, effects_1.put(RefinanceAction_1.default.setResult(refinanceResult))];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var refinanceCalculateClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(RefinanceAction_1.default.ON_CALCULATE_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(RefinanceAction_1.default.onCalculate())];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MortgageCommonAction_1.default.setResultVisible(true))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var refinanceUpdate = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take([RefinanceAction_1.default.ON_OUTSTANDING_MORTGAGE_CHANGED, RefinanceAction_1.default.ON_CURRENT_TENOR_CHANGED, RefinanceAction_1.default.ON_EXISTING_INTEREST_RATE_CHANGED, RefinanceAction_1.default.ON_NEW_PROPERTY_VALUE_CHANGED, RefinanceAction_1.default.ON_NEW_LOAN_CHANGED, RefinanceAction_1.default.ON_NEW_LOAN_PERCENT_CHANGED, RefinanceAction_1.default.ON_NEW_TENOR_CHANGED, RefinanceAction_1.default.ON_NEW_INTEREST_RATE_CHANGED])];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(RefinanceAction_1.default.onCalculate())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var articleAutoExpand = function () {
    var channel, hash, hashPcs, index;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(WindowApi_1.hashChangeListener)];
            case 1:
                channel = _a.sent();
                _a.label = 2;
            case 2:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(channel)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.getHash)];
            case 4:
                hash = _a.sent();
                hashPcs = hash.split('-');
                if (!(hashPcs.length === 2 && hashPcs[1] === Number(hashPcs[1]).toString())) return [3 /*break*/, 6];
                index = Number(hashPcs[1]);
                return [4 /*yield*/, effects_1.put(MortgageCommonAction_1.default.onArticleToggled(index))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 2];
            case 7: return [2 /*return*/];
        }
    });
};
var scrollToMorgageResult = function () {
    var resultElm = document.getElementById('result');
    if (!resultElm)
        return;
    document.getElementsByTagName('html')[0].scrollTop = resultElm.offsetTop;
};
var autoScrollToResult = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take([RefinanceAction_1.default.ON_CALCULATE_CLICKED, AffordabilityAction_1.default.ON_CALCULATE_CLICKED, MortgageMonthlyAction_1.default.ON_CALCULATE_CLICKED])];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(100)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.call(scrollToMorgageResult)];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var mortgageCommonSagas = {
    mortgageMonthlyInit: mortgageMonthlyInit,
    mortgageMonthlyCalculateClick: mortgageMonthlyCalculateClick,
    mortgageMonthlyUpdate: mortgageMonthlyUpdate,
    mortgageMonthlyUpdateAutoLoanAmount: mortgageMonthlyUpdateAutoLoanAmount,
    affordabilityInit: affordabilityInit,
    affordabilityCalculateClick: affordabilityCalculateClick,
    affordabilityUpdate: affordabilityUpdate,
    refinanceInit: refinanceInit,
    refinanceCalculateClick: refinanceCalculateClick,
    refinanceUpdate: refinanceUpdate,
    articleAutoExpand: articleAutoExpand,
    autoScrollToResult: autoScrollToResult,
};
exports.mortgageCommonSagas = mortgageCommonSagas;
